import React, { Component } from "react";
import MapContainer from "./MapContainer";

class MapPage extends Component {
  render() {
    return <MapContainer />;
  }
}

export default MapPage;
